"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubHorizonInvestissementTrads = void 0;
exports.ESubHorizonInvestissementTrads = {
    between_1_5_ans: "Entre 1 et 5 ans",
    between_5_10_ans: "Entre 5 et 10 ans",
    greater_10_ans: "Supérieur à 10 ans",
};
